// swatches

export const MAT_COLOR_SWATCHES = [
	{
		color: 'black',
    name: 'Black',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/q-leather-black.jpg'
      }
    ]
	},
	{
		color: 'grey',
    name: 'Grey',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/q-leather-grey.jpg'
      }
    ]
	},
	{
		color: 'tan',
    name: 'Tan',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/q-leather-tan.jpg'
      }
    ]
	},
	{
		color: 'cream',
    name: 'Cream',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/q-leather-cream.jpg'
      }
    ]
	},
	{
		color: 'red',
    name: 'Red',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/q-leather-red.jpg'
      }
    ]
	},
	{
		color: 'burgundy',
    name: 'Burgundy',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/q-leather-burgundy.jpg'
      }
    ]
	}
];

export const BORDER_COLOR_SWATCHES = [
	{
		color: 'black',
		name: 'Black',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/BlackBindingV2.png'
      }
    ]
	},
	{
		color: 'grey',
		name: 'Grey',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/GreyBindingV2.png'
      }
    ]
	},
	{
		color: 'tan',
		name: 'Tan',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/TanBindingV2.png'
      }
    ]
	},
	{
		color: 'cream',
		name: 'Cream',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/CreamBindingV2.png'
      }
    ]
	},
	{
		color: 'sand',
		name: 'Sand',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/SandBindingV2.png'
      }
    ]
	},
	{
		color: 'red',
		name: 'Red',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/RedBindingV2.png'
      }
    ]
	},
	{
		color: 'burgundy',
		name: 'Burgundy',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/BurgundyBindingV2.png'
      }
    ]
	},
	{
		color: 'brown',
		name: 'Brown',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/BrownBindingV2.png'
      }
    ]
	},
	{
		color: 'silver',
		name: 'Silver',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/SilverBindingV2.png'
      }
    ]
	},
	{
		color: 'white',
		name: 'White',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/WhiteBindingV2.png'
      }
    ]
	},
	{
		color: 'blue',
		name: 'Blue',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/BlueBindingV2.png'
      }
    ]
	},
	{
		color: 'yellow',
		name: 'Yellow',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/YellowBindingV2.png'
      }
    ]
	},
	{
		color: 'orange',
		name: 'Orange',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/OrangeBindingV2.png'
      }
    ]
	},
	{
		color: 'purple',
		name: 'Purple',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/PurpleBindingV2.png'
      }
    ]
	},
	{
		color: 'lime',
		name: 'Lime',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/LimeBindingV2.png'
      }
    ]
	}
];

export const PAD_COLOR_SWATCHES = [
	{
		color: 'black',
		name: 'Black',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/leather-black.jpg'
      }
    ]
	},
	{
		color: 'grey',
		name: 'Grey',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/leather-grey.jpg'
      }
    ]
	},
	{
		color: 'tan',
		name: 'Tan',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/leather-tan.jpg'
      }
    ]
	},
	{
		color: 'cream',
		name: 'Cream',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/leather-cream.jpg'
      }
    ]
	},
	{
		color: 'red',
		name: 'Red',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/leather-red.jpg'
      }
    ]
	},
	{
		color: 'burgundy',
		name: 'Burgundy',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/leather-burgundy.jpg'
      }
    ]
	}
];

export const STITCHING_COLOR_SWATCHES = [
	{
		color: 'black',
		name: 'Black',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/BlackStitching.png'
      }
    ],
	},
	{
		color: 'cream',
		name: 'Cream',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/CreamStitching.png'
      }
    ],
	},
	{
		color: 'tan',
		name: 'Tan',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/TanStitching.png'
      }
    ],
	},
	{
		color: 'sand',
		name: 'Sand',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/SandStitching.png'
      }
    ],
	},
	{
		color: 'red',
		name: 'Red',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/RedStitching.png'
      }
    ],
	},
	{
		color: 'burgundy',
		name: 'Burgundy',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/BurgundyStitching.png'
      }
    ],
	},
	{
		color: 'brown',
		name: 'Brown',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/BrownStitching.png'
      }
    ],
	},
	{
		color: 'silver',
		name: 'Silver',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/SilverStitching.png'
      }
    ],
	},
	{
		color: 'white',
		name: 'White',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/WhiteStitching.png'
      }
    ],
	},
	{
		color: 'charcoal',
		name: 'Charcoal',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/CharcoalStitching.png'
      }
    ],
	},
	{
		color: 'beige',
		name: 'Beige',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/BeigeStitching.png'
      }
    ],
	},
	{
		color: 'copper',
		name: 'Copper',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/CopperStitching.png'
      }
    ],
	},
	{
		color: 'string',
		name: 'String',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/StringStitching.png'
      }
    ],
	},
	{
		color: 'seafoam',
		name: 'Seafoam',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/SeafoamStitching.png'
      }
    ],
	},
	{
		color: 'bright-blue',
		name: 'Bright Blue',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/BrightBlueStitching.png'
      }
    ],
	},
	{
		color: 'pale-blue',
		name: 'Pale Blue',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/PaleBlueStitching.png'
      }
    ],
	},
	{
		color: 'medium-blue',
		name: 'Medium Blue',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/MediumBlueStitching.png'
      }
    ],
	},
	{
		color: 'dark-blue',
		name: 'Dark Blue',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/DarkBlueStitching.png'
      }
    ],
	},
	{
		color: 'yellow',
		name: 'Yellow',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/YellowStitching.png'
      }
    ],
	},
	{
		color: 'gold',
		name: 'Gold',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/GoldStitching.png'
      }
    ],
	},
	{
		color: 'orange',
		name: 'Orange',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/OrangeStitching.png'
      }
    ],
	},
	{
		color: 'green',
		name: 'Green',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/GreenStitching.png'
      }
    ],
	},
	{
		color: 'hunter-green',
		name: 'Hunter Green',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/HunterGreenStitching.png'
      }
    ],
	},
	{
		color: 'purple',
		name: 'Purple',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/PurpleStitching.png'
      }
    ],
	},
	{
		color: 'lime',
		name: 'Lime',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/LimeStitching.png'
      }
    ],
	},
	{
		color: 'pink',
		name: 'Pink',
    images: [
      {
        type: 'swatch',
        imageUrl: '//cdn.shopify.com/s/files/1/0027/5539/5641/files/PinkStitching.png'
      }
    ],
	}
];
